import { languages } from "../constants/languages";
import defaultFases from "../constants/DefaultFases";

export const getResultSpotName = (
  resultSpot,
  resultSpotsAll,
  poulesByKey,
  divisions
) => {
  let name =
    ((poulesByKey[resultSpot.fromPoule] || {}).singleMatch
      ? languages.structure.ranksSingleMatch[resultSpot.rank]
      : languages.structure.ranks[resultSpot.rank]) +
      " " +
      (poulesByKey[resultSpot.fromPoule] || {}).name || "";

  let division = divisions[resultSpot.division] || {};

  if (resultSpot.type === 1) {
    const resultSpotsWithRank = resultSpotsAll
      .filter(
        (rs) =>
          rs.fase === resultSpot.fase &&
          rs.rank === resultSpot.rank &&
          rs.division === resultSpot.division
      )
      .sort((a, b) => {
        if (
          (poulesByKey[a.fromPoule] || {}).indexNum >
          (poulesByKey[b.fromPoule] || {}).indexNum
        ) {
          return 1;
        } else if (
          (poulesByKey[a.fromPoule] || {}).indexNum <
          (poulesByKey[b.fromPoule] || {}).indexNum
        ) {
          return -1;
        } else {
          return (
            (poulesByKey[a.fromPoule] || {}).num -
            (poulesByKey[b.fromPoule] || {}).num
          );
        }
      })
      .map((rs) => rs.id);
    const num = resultSpotsWithRank.indexOf(resultSpot.id);
    name =
      languages.structure.ranks[num] +
      " " +
      languages.structure.number +
      " " +
      (resultSpot.rank + 1) +
      " " +
      ((division.fases || defaultFases)[resultSpot.fase] || {}).name;
  }
  return name;
};
